import { Component, Input, OnInit, SimpleChanges } from "@angular/core";

@Component({
  selector: "kwikui-label-value-pair-separator",
  templateUrl: "./label-value-pair-separator.component.html",
  styleUrls: ["./label-value-pair-separator.component.css"]
})
export class LabelValuePairSeparatorComponent implements OnInit {
  @Input()
  separator;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty("separator") && !changes.separator.firstChange) {
      this.separator = changes.separator.currentValue;
    }
  }
}
